// Copyright (c) Microsoft. All rights reserved.

import { makeStyles } from '@fluentui/react-components';
import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { IChatMessage } from '../../../libs/models/ChatMessage';
import * as utils from './../../utils/TextUtils';
const useClasses = makeStyles({
    content: {
        wordBreak: 'break-word',
        '& img': {
            maxWidth: '30vw',
            verticalAlign: 'text-top',
            display: 'block',
            cursor: 'pointer'

        }
    },
    modalImage: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        zIndex: '1000',
        left: '0',
        top: '0',
        width: '100%',
        height: '100%'
    },
    modalContent: {
        maxWidth: '80%', /* Make sure the image is responsive */
        maxHeight: '80%',
        // height: 'auto'
    },
    closeModal: {
        // position: 'absolute',
        // top: '20px',
        // right: '35px',
        margin: '5px 0px',
        color: 'orange',
        fontSize: '40px',
        fontWeight: 'bold',
        cursor: 'pointer'
    }
});

interface ChatHistoryTextContentProps {
    message: IChatMessage;
}

export const ChatHistoryTextContent: React.FC<ChatHistoryTextContentProps> = ({ message }) => {
    const classes = useClasses();
    // const content = utils.replaceCitationLinksWithIndices(utils.formatChatTextContent(message.content), message);
    const content = utils.formatChatTextContent(message.content);

    // State to control the modal
    const [isOpen, setIsOpen] = useState(false);
    const [isListenerAttached, setListenerAttached] = useState(false);
    const [modalImageSrc, setModalImageSrc] = useState('');

    // Function to open the modal and set the clicked image source
    const openModal = (src: string) => {
        setModalImageSrc(src);
        setIsOpen(true);
    };

    // Function to close the modal
    const closeModal = () => {
        setIsOpen(false);
        setModalImageSrc(''); // Reset the image source when modal closes
    };



    // Attach event listener to the document or a specific container
    React.useEffect(() => {
        const images = document.querySelectorAll('img');  // Select all <img> elements
        // Event listener to handle clicks on images dynamically
        const handleImageClick = (e: MouseEvent) => {
            const target = e.target as HTMLImageElement;
            console.log('target', target);

            if (target.tagName == 'IMG') {
                if (!isOpen) {
                    openModal(target.src);
                }

            }
        };
        if (!isListenerAttached) {
            // // document.addEventListener('click', handleImageClick);
            images.forEach((img) => {
                img.addEventListener('click', handleImageClick);
            });
            //console.log('handleImageClick');
            setListenerAttached(true);
        }
        // Cleanup the event listener on unmount
        return () => {
            // // document.removeEventListener('click', handleImageClick);
            images.forEach((img) => {
                img.removeEventListener('click', handleImageClick);
            });
        };
    }, []);

    if (isOpen) {
        return (
            <>
                {/* Modal for full image display */}
                <div className={classes.modalImage} >
                    <img className={classes.modalContent} src={modalImageSrc} alt="Full size" />
                    <button className={classes.closeModal} onClick={closeModal}>&times;</button>
                </div>
            </>
        );
    }


    return (
        <div className={`${classes.content} bot-response-wrapper`}>
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
        </div>
    );
};
